import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import { BOOKS_FOR_PAGE, API_URL } from '@/helpers/variables';
import SeriesDetail from '@/components/screens/series-detail/SeriesDetail';
import { ISeriesBooksPage } from '@/interfaces/seriesBooksPage.interface';

interface ISeriesPageDynamicProps {
  books: ISeriesBooksPage;
}

const SeriesPageDynamic: NextPage<ISeriesPageDynamicProps> = ({ books }) => {
  return <SeriesDetail books={books as ISeriesBooksPage} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { alias } = context.query;

  const res = await fetch(`${API_URL}series/?status=active&alias=${alias}&status=active&page=1&page_size=${BOOKS_FOR_PAGE}&book_page=1&book_page_size=${BOOKS_FOR_PAGE}`);

  if (res.status === 404) {
    const errorResponse = await res.json();
    const redirectUrl = errorResponse.detail?.url;

    if (redirectUrl) {
      return {
        redirect: {
          destination: redirectUrl,
          permanent: true,
        },
      };
    }
  }

  // Check Fetched Data Error
  if (!res.ok) {
    console.table(`Error ${res.status}. Api: ${res.url}`);
    return {
      notFound: true,
    };
  }

  const books = await res.json();

  // Check Fetched Data Error
  if (books?.data.length === 0) {
    return {
      notFound: true,
    };
  }

  return {
    props: { books },
  };
};

export default SeriesPageDynamic;
